import React from 'react';
import Dialog from "@mui/material/Dialog";
import './index.scss';

class PrivacyStatement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    
    render() {
        const { open, close } = this.props;
        return (
            <div>
                <Dialog
                    onClose={close}
                    aria-labelledby="simple-dialog-title"
                    open={open}
                >
                    <div className='privacy-popup-body'>
                        <div>
                            <div id="privacy-container" class="inner-container">
                                <div class="group-item">
                                    <label class="group-item-label"><h2>Privacy Statement</h2></label>
                                    <div class="title-next">
                                        <p>This chat will be recorded and used for quality assurance and training purposes, and to help us serve you better.</p>
                                        <p>Chat Session data and transcripts will be stored for up to 7 years from the date of collection.</p>
                                        <p>Please <strong>do not share any sensitive information</strong> during the chat such as personal information or credit cards.</p>
                                        <p>Click the checkbox to agree to these terms.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='privacy-popup-buttons'>
                            <button className="privacy-button"
                                onClick={close} >
                                <i aria-hidden="true" />
                               OK
                           </button>
                        </div>
                    </div>
                </Dialog>
            </div>
        )
    }
}
export default PrivacyStatement;